import { render, staticRenderFns } from "./term-table.vue?vue&type=template&id=1723c3d8&"
import script from "./term-table.vue?vue&type=script&lang=js&"
export * from "./term-table.vue?vue&type=script&lang=js&"
import style0 from "./term-table.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports